import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { supplierUrls } from "../../URL/ApplicationUrls";
import Supplier from "../Supplier";
import { namedQueryKeyWithId } from "../../ReactQuery/namedQueryKeyWithId";

export const useFetchSupplier = (supplierId: number | string | undefined) => {
  return useQuery<Supplier, Error>({
    queryKey: namedQueryKeyWithId("suppliers", supplierId),
    queryFn: () => fetchSupplier(supplierId),
    onError: () => {
      toast.error(`An error occurred when retrieving the supplier with the Id ${supplierId}`);
    },
  });
};

const fetchSupplier = async (id: number | string | undefined) => {
  const { data: supplier } = await axios.get<Supplier>(supplierUrls.supplierWithId(id).apiUrl);

  return supplier;
};
